/** 电费调价记录 /metering/fee/electricity-adjustment（electricityAdjustment.vue） */
export default {
  electricityAdjustmentPage: {
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    phStartDate: '开始日期',
    phResult: '改价结果',
    optAll: '全部',
    optSuccess: '成功',
    optFail: '失败',
    phSerial: '电表序列号',
    sectionTitle: '电费调价记录',
    selectionBefore: '已选择 ',
    selectionAfter: ' 条数据',
    emptyTable: '暂无数据',
    emptyNoPermission: '暂无查看权限',
    colRid: '流水号',
    colMeter: '电表(ID)',
    colSerial: '电表序列号',
    colPricePlan: '计费方案(ID)',
    colPrices: '电价(尖/峰/平/谷)',
    colTime: '时间',
    colResult: '改价结果',
    colAction: '操作',
    resultSuccess: '调价成功',
    resultFail: '调价失败',
    resultExpired: '已失效',
    btnDetail: '详情',
    btnRetry: '重试',
    dialogDetailTitle: '调价详情',
    labelOpDesc: '操作描述：',
    labelRemark: '备注：',
    btnClose: '关闭',
    detailNoDesc: '无',
    detailParseFail: '解析失败',
    msgLoadFail: '获取数据失败',
    msgFetchFail: '获取调价记录失败',
    msgNoOperate: '暂无操作权限',
    titleTip: '提示',
    btnOk: '确定',
    btnCancel: '取消',
    confirmRetry: '确认重新修改?',
    msgRetryOk: '重试成功',
    msgOpFail: '操作失败',
    msgRetryFail: '重试失败',
    msgRetryError: '重试操作失败',
    msgNoExport: '没有可导出的数据',
    exportFileName: '调价记录.xlsx',
    msgExportDev: '导出功能开发中...',
    // 导出（本页/选中/全部）统一文案
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    msgNoDataExport: '没有可导出的数据',
    warnNoSelectedExport: '请先选择要导出的数据',
    msgExportOk: '导出成功，共 {count} 条',
    msgExportOkSelected: '导出成功，共 {count} 条',
    msgExportFail: '导出失败',
    successExported: '导出成功，共 {count} 条',
    successExportedLimit: '命中 {total} 条，单次最多导出 {count} 条，已导出前 {count} 条',
    exporting: '正在导出全部数据...',
    exportSheetName: '调价记录',
    filePrefix: '调价记录'
  }
}
